export const BUTTON_ROLES: { [key: string]: any } = {
  internal: 'link',
  external: 'link',
  file: 'link',
  submit: 'button',
};

export const BUTTON_TYPES: { [key: string]: any } = {
  internal: 'internal',
  external: 'external',
  file: 'file',
  primary: 'primary',
  secondary: 'secondary',
  action: 'action',
  submit: 'submit',
  button: 'button',
};

export const ICON_TYPES: { [key: string]: any } = {
  internal: 'internal',
  external: 'external',
  download: 'download',
  file: 'file',
  none: 'none',
  start: 'start',
  end: 'end',
  close: 'close',
  mail: 'mail',
  primary: 'primary',
  arrow: 'arrow',
  chevron: 'chevron',
  default: 'default',
  arrowLeft: 'arrow-left',
  arrowRight: 'arrow-right',
  chevronLeft: 'chevron-left',
  chevronDown: 'chevron-down',
  arrowReload: 'arrow-reload',
  info: 'info',
  arrowLarge: 'arrow-large',
  calculator: 'calculator',
  magnifyingGlass: 'magnifying-glass',
  rocket: 'rocket',
  sheet: 'sheet',
  document: 'document',
};

export const ICON_POSITIONS: { [key: string]: any } = {
  start: 'start',
  end: 'end',
};

export const BUTTON_THEMES: { [key: string]: any } = {
  default: 'default',
  highlight: 'highlight',
  muted: 'muted',
  disabled: 'disabled',
  link: 'link',
  choiceButton: 'choiceButton',
  defaultWhite: 'defaultWhite',
};
